import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {LegalForm} from '@domain/host/host.dto';

@Pipe({
  name: 'legalForm',
  pure: true
})
export class LegalFormPipe implements PipeTransform {

  private readonly transloco = inject(TranslocoService);

  public transform(legalForm: LegalForm | null): string | null {
    if (!legalForm) {
      return null;
    }
    return this.transloco.translate(`enum.Host.LegalForm.${legalForm}`).toLowerCase();
  }

}
